import { Role, userRolesIndex } from 'store/user/auth0.helpers';
import { UseUserState } from 'store/user/useUser';

/**
 * THE PERMISSIONS PYRAMID ▲
 *
 * System admin is just system admins
 * Inspectors are system admins and inspectors
 * Reviewers are system admins, inspectors and reviewers
 */

export const systemAdminRoles: Role[] = [Role.MkSystemAdmin, Role.MkSystemOperator];

export const approverRoles: Role[] = [...systemAdminRoles];

export const satoRoles: Role[] = [...approverRoles, Role.SatoVideoReviewer];

export const adminRoles: Role[] = [Role.Admin, ...approverRoles];

export const reviewerRoles: Role[] = [...adminRoles];

export const entryRoles: Role[] = [Role.SaviUser, Role.SatoUser, Role.SaviSatoUser, ...reviewerRoles];

export const jnjAdminRoles: Role[] = [Role.Admin];

/**
 *
 * @param userRoles
 * @param rolesWithPermission
 * @returns
 */
export const userHasPermissions = (user: UseUserState, rolesWithPermission: Role[]): boolean => {
  if (!user.isAuthenticated) {
    return false;
  }

  if (rolesWithPermission.length < 1) {
    return true;
  }

  return user[userRolesIndex].some(userRole => rolesWithPermission.includes(userRole));
};

/**
 *
 * @param user
 * @returns whether the user is an system admin
 */
export const isSystemAdmin = (user: UseUserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, systemAdminRoles);

/**
 *
 * @param user
 * @returns whether the user is a reviewer
 */
export const isReviewer = (user: UseUserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, reviewerRoles);

/**
 *
 * @param user
 * @returns whether the user is a reviewer
 */
export const isInMaxKelsenOrg = (user: UseUserState): boolean => {
  return user.isAuthenticated && user.org_id === process.env.REACT_APP_AUTH0_MK_ORGANIZATION;
};

export const isInJnJOrg = (user: UseUserState): boolean => {
  return user.isAuthenticated && user.org_id === process.env.REACT_APP_AUTH0_ORGANIZATION;
};

export const isInHSSOrg = (user: UseUserState): boolean =>
  user.isAuthenticated && user.org_id === process.env.REACT_APP_AUTH0_HSS_ORGANIZATION;

export const isInDemoOrg = (user: UseUserState): boolean =>
  user.isAuthenticated && user.org_id === process.env.REACT_APP_AUTH0_DEMO_ORGANIZATION;

export const isSatoVideoReviewer = (user: UseUserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, [Role.SatoVideoReviewer]);

export const isJnJAdmin = (user: UseUserState): boolean =>
  user.isAuthenticated && userHasPermissions(user, jnjAdminRoles);
